<!-- 滚轮横向滚动组件 -->
<template>
  <div class="horwheel-img">
    <div id="camera">
      <!-- 底图部分 -->
      <img id="camera-long-img" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/bg.jpg" />
      <!-- 转场后人物 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png" class="absolute cloud-ani" alt="static" data-wd="992" data-left="2000" data-top="19" />
      <div data-alt="speed" class="absolute left-0" data-wd="657" data-left="1309">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person1.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0 cursor-pointer z-index--1" data-wd="301" data-left="1202" id="playMp4" data-top="105" @click="showModal('camera')">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/play-mp4.png" class="width-100" />
      </div>

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/talk9.png" id="talk9" class="after-talk9 opacity-0" data-wd="579" data-left="2305" data-top="87" />
      <!-- 转场前遮挡 -->
      <img id="camera-before-img" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/before2.jpg" class="before" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="1261" data-top="-20" />
      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png" class="absolute cloud-ani" alt="static" data-wd="600" data-left="2500" data-top="50" />
      <!-- 头部 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/head_3.png" class="absolute" alt="static" data-wd="1131" data-left="0" data-top="0" />

      <!-- 前言 -->
      <div data-alt="speed" class="absolute left-0" data-wd="650" data-left="150" data-top="151">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/title.png" class="width-100" />
      </div>
      <!-- 转场按钮 -->
      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/talk12.png" class="absolute" alt="static" data-wd="458" data-left="1012" data-top="114" />
      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/wyb.gif" class="absolute opacity-0" alt="static" data-wd="180" data-left="914" data-top="97" data-active="ani3" data-left-percentage="0.7" id="camera-talk1" />
      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/btn3.png" class="before-btn cursor-pointer" @click="handleShowResult" />

      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/hand.png" class="before-btn-hand cursor-pointer ani-opacity" @click="handleShowResult" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png" class="absolute cloud-ani" alt="static" data-wd="992" data-left="8444" data-top="19" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="9888" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png" class="absolute cloud-ani" alt="static" data-wd="1244" data-left="11044" data-top="-90" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="13388" data-top="-10" />

      <!-- <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/talk10.png" class="img-static-bg" alt="static" data-left-percentage="0.9" data-active="ani1" data-wd="237" data-left="4122" data-top="146" /> -->

      <div class="flip-card" data-left-percentage="0.7" id="flip-card1" data-left="2900" data-top="300">
        <div class="flip-card-item">
          <div class="flip-card-item-img-wrap">
            <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/pic3.png" />
          </div>
        </div>
        <div class="flip-card-item" style="margin-top: 60px">
          <div class="flip-card-item-img-wrap">
            <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/pic1.png" />
          </div>
        </div>
      </div>

      <div class="flip-card" data-left-percentage="0.7" id="flip-card2" data-left="3963" data-top="300">
        <div class="flip-card-item" style="margin-top: 60px">
          <div class="flip-card-item-img-wrap">
            <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/pic4.png" />
          </div>
        </div>
        <div class="flip-card-item">
          <div class="flip-card-item-img-wrap">
            <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/pic2.png" />
          </div>
        </div>
      </div>

      <!-- <div data-alt="speed" class="absolute left-0" data-wd="481" data-left="4337" data-left-percentage="0.7" id="camera-kuaimen">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/camera.png" class="width-100" />
      </div> -->

      <div data-alt="speed" class="absolute left-0" data-wd="521" data-left="3594" data-top="86">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/talk13.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="464" data-left="4770" data-top="144">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/talk1.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="572" data-left="5278">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person3.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="344" data-left="5614" data-top="124">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/tlk15.png" class="width-100 opacity-0" />
      </div>
      <div data-alt="speed" class="absolute left-0" data-wd="681" data-left="6306" data-top="579">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/fish2.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.9" data-wd="324" data-left="7500" data-top="252">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/talk11.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="951" data-left="7600">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person5.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.9" data-wd="555" data-left="8467" data-top="120">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/talk8.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="380" data-left="8896" data-top="367">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person4.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.9" data-wd="429" data-left="9300" data-top="308">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/talk14.png" class="width-100 opacity-0" />
      </div>

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person2.png" class="person2" data-wd="2733" data-left="9130" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person6.png" class="absolute" alt="static" data-wd="1511" data-left="12140" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/q1.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="405" data-left="12483" data-top="874" @click="changeAnswer1()" :class="{ ani1: question }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/q2.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="342" data-left="12929" data-top="874" @click="changeAnswer2()" :class="{ ani1: question }" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/c.png" class="absolute cursor-pointer" alt="static" data-wd="328" data-left="12704" data-top="895" @click="changeFlag('question')" :style="{ 'z-index': question ? '-1' : '0' }" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/a1.png" class="absolute opacity-0" alt="static" data-wd="584" data-left="12971" data-top="175" :class="{ ani1: answer2, 'z-index--1': !answer2 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/a2.png" class="absolute opacity-0" alt="static" data-wd="584" data-left="12971" data-top="175" :class="{ ani1: answer1, 'z-index--1': !answer1 }" />

      <!-- 可点击区域 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/q8.png" class="absolute opacity-0" :class="{ ani1: personControl.q8 }" alt="static" data-wd="437" data-left="11515" data-top="307" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/q7.png" class="absolute opacity-0" :class="{ ani1: personControl.q7 }" alt="static" data-wd="437" data-left="11221" data-top="194" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/q5.png" class="absolute opacity-0" :class="{ ani1: personControl.q5 }" alt="static" data-wd="437" data-left="10546" data-top="282" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/q4.png" class="absolute opacity-0" :class="{ ani1: personControl.q4 }" alt="static" data-wd="437" data-left="10188" data-top="299" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/q3.png" class="absolute opacity-0" :class="{ ani1: personControl.q3 }" alt="static" data-wd="437" data-left="9858" data-top="245" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/z4.png" class="absolute opacity-0" :class="{ ani1: personControl.z4 }" alt="static" data-wd="437" data-left="11025" data-top="107" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/z3.png" class="absolute opacity-0" :class="{ ani1: personControl.z3 }" alt="static" data-wd="437" data-left="10346" data-top="207" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/z2.png" class="absolute opacity-0" :class="{ ani1: personControl.z2 }" alt="static" data-wd="437" data-left="10072" data-top="206" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/h5.png" class="absolute opacity-0" :class="{ ani1: personControl.h5 }" alt="static" data-wd="437" data-left="10738" data-top="104" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/h4.png" class="absolute opacity-0" :class="{ ani1: personControl.h4 }" alt="static" data-wd="437" data-left="10495" data-top="94" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/h3.png" class="absolute opacity-0" :class="{ ani1: personControl.h3 }" alt="static" data-wd="437" data-left="10232" data-top="83" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/h2.png" class="absolute opacity-0" :class="{ ani1: personControl.h2 }" alt="static" data-wd="437" data-left="9941" data-top="104" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/persons/h1.png" class="absolute opacity-0" :class="{ ani1: personControl.h1 }" alt="static" data-wd="437" data-left="9621" data-top="156" />
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="11734" data-top="993" @click="changePersonControl('q8')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="11425" data-top="951" @click="changePersonControl('q7')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10759" data-top="976" @click="changePersonControl('q5')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10391" data-top="1001" @click="changePersonControl('q4')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10071" data-top="976" @click="changePersonControl('q3')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="11247" data-top="793" @click="changePersonControl('z4')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10563" data-top="868" @click="changePersonControl('z3')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10282" data-top="859" @click="changePersonControl('z2')"></div>

      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10914" data-top="734" @click="changePersonControl('h5')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10695" data-top="719" @click="changePersonControl('h4')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="10445" data-top="722" @click="changePersonControl('h3')"></div>
      <div class="dot-ani-red cursor-pointer" data-alt="position" data-left="10172" data-top="737" @click="changePersonControl('h2')"></div>
      <div class="dot-ani cursor-pointer" data-alt="position" data-left="9805" data-top="773" @click="changePersonControl('h1')"></div>
      <!-- <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/fish.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.7" data-wd="640" data-left="1667" data-top="599" /> -->
    </div>
    <img v-if="showMouseTip" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mouse.png" class="mouse-tip ani-opacity" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 横向滚动视差滚动对象
let parallax = {
  segment: 15,
  screenWidth: 0,
  dom: null,
  speed: 0.5,
  scrollLeft: 0,
  scrollLeftWithScreen: 0,
  scrollMaxLeft: 0,
  wheelStep: 0,
  minStep: 0,
  curStep: 0,
  longImgWidth: 0,
  longImgRealWidth: 14227,
  longImgRealHeight: 1080,
  imgScale: 1,
  layers: [],
  staticDoms: [],
  music: [],
  extraDom: []
}
let timer
let doingNextMove = false
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showMouseTip: true,
      // 是否转场
      showResult: false,
      personControl: {
        q8: false,
        q7: false,
        q5: false,
        q4: false,
        q3: false,
        z4: false,
        z3: false,
        z2: false,
        h5: false,
        h4: false,
        h3: false,
        h2: false,
        h1: false
      },
      end: false,
      question: false,
      answer1: false,
      answer2: false,
      answer3: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    reset() {
      if (this.showMouseTip) return
      this.end = false
      this.showResult = false
      this.question = false
      this.answer1 = false
      this.answer2 = false
      this.answer3 = false
      this.showMouseTip = true
      for (const key in this.personControl) {
        this.personControl[key] = false
      }
      const beforeImg = document.getElementById('camera-before-img')
      const talk9 = document.getElementById('talk9')
      const playMp4 = document.getElementById('playMp4')
      beforeImg.style.opacity = 1
      beforeImg.style.display = 'block'
      playMp4.style.zIndex = -1
      if (talk9.classList.contains('ani1')) {
        talk9.classList.remove('ani1')
      }
      parallax.layers = []
      parallax.staticDoms = []
      parallax.music = []
      parallax.extraDom = []
      parallax.dom.style.transform = `translate3d(0, 0, 0)`
      parallax.scrollLeft = 0
      parallax.curStep = 0
      this.init()
    },
    changeAnswer1() {
      this.answer1 = true
      this.answer2 = false
      this.answer3 = false
    },
    changeAnswer2() {
      this.answer1 = false
      this.answer2 = true
      this.answer3 = false
    },
    changeAnswer3() {
      this.answer1 = false
      this.answer2 = false
      this.answer3 = true
    },
    changeFlag(flag) {
      this[flag] = !this[flag]
      console.log('flag:', flag, this[flag])
    },
    changePersonControl(position) {
      for (const key in this.personControl) {
        this.personControl[key] = key === position
      }
    },
    handleShowResult() {
      const beforeImg = document.getElementById('camera-before-img')
      const talk9 = document.getElementById('talk9')
      const playMp4 = document.getElementById('playMp4')
      beforeImg.style.opacity = 0
      setTimeout(() => {
        beforeImg.style.display = 'none'
        playMp4.style.zIndex = 1
        talk9.classList.add('ani1')
        this.showMouseTip = true
      }, 1000) // 设置与CSS中的过渡时间一致
      this.showResult = true
    },
    init() {
      this.aniInit()
      this.wheelInit()
    },
    showMp3(mode) {
      let bgImg = ''
      let width = 0
      let height = 0
      let closeRight = 0
      let closTop = 0
      if (mode === 'field-ganyan') {
        bgImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/chen-mp3-1.png'
        width = 501
        height = 675
        closeRight = 30
        closTop = 120
      }
      this.$emit('openMp3Modal', { mode, bgImg, width, height, closeRight, closTop })
    },
    showModal(mode) {
      let backgroundColor = ''
      let titleImg = ''
      let videoUrl = ''
      if (mode === 'camera') {
        backgroundColor = '#f4bc45'
        titleImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png'
        videoUrl = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/camera/xjf.mp4'
      }
      this.$emit('openModal', { mode, backgroundColor, titleImg, videoUrl })
    },
    aniInit() {},
    wheelInit() {
      // 获取监听滚轮事件
      parallax.dom = document.getElementById('camera')
      // 获取主要滚动dom
      const image = document.getElementById('camera-long-img')
      // console.log('image.width：', image.width)
      parallax.longImgWidth = image.width
      parallax.dom.style.width = image.width + 'px'
      parallax.imgScale = image.width / parallax.longImgRealWidth
      // 获取屏幕宽度
      parallax.screenWidth = window.innerWidth || (document.body && document.body.clientWidth)
      // 最大滚动到左侧距离
      parallax.scrollMaxLeft = parallax.longImgWidth - parallax.screenWidth
      // 每一次距离(屏幕宽度 / 15 * 速率)
      parallax.wheelStep = (parallax.screenWidth / parallax.segment) * parallax.speed
      // 滚动最小距离
      parallax.minStep = parallax.screenWidth / 1000 / parallax.segment
      // 获取滚动到长图的距离 首次进入就是宽度
      parallax.scrollLeftWithScreen = parallax.screenWidth
      // 获取所有要滚动的图片
      this.initChildren()
      console.log('camera-parallax:', parallax)
      // 添加滚轮监听事件
      parallax.dom.addEventListener('wheel', this.handleWheel)
    },
    initPosition(element) {
      const realWidth = element.getAttribute('data-wd')
      const realLeft = element.getAttribute('data-left')
      const realTop = element.getAttribute('data-top')
      if (element.hasAttribute('data-wd')) {
        element.style.width = (realWidth / parallax.longImgRealWidth) * 100 + '%'
      }
      element.style.left = (realLeft / parallax.longImgRealWidth) * 100 + '%'
      if (element.hasAttribute('data-top')) {
        element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
      } else {
        element.style.bottom = 0
      }
    },
    initChildren() {
      // 配置图片
      for (let i = 0; i < parallax.dom.children.length; i++) {
        const element = parallax.dom.children[i]
        if (element.getAttribute('data-alt') === 'speed') {
          // 处理动态
          const speed = element.getAttribute('speed') || 1.1
          const realWidth = element.getAttribute('data-wd')
          const realLeft = element.getAttribute('data-left')
          const realTop = element.getAttribute('data-top')
          let left = realLeft * parallax.imgScale
          left += left / 15
          const layer = {
            dom: element,
            realWidth,
            realLeft,
            speed: Number(speed),
            width: realWidth * parallax.imgScale,
            left: left,
            initLeft: left
          }
          parallax.layers.push(layer)
          // 处理div节点样式
          element.style.width = layer.width + 'px'
          if (element.hasAttribute('data-top')) {
            element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
          } else {
            element.style.bottom = 0
          }
          element.style.transform = `translate3d(${layer.left}px, 0, 0)`
          // 处理内层动画节点样式
          const imgDom = element.children[0]
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (imgDom.classList.contains(activeClass)) {
            imgDom.classList.remove(activeClass)
          }
          const leftPercentage = element.getAttribute('data-left-percentage') || 0.7
          parallax.staticDoms.push({
            dom: imgDom,
            activeClass,
            leftPercentage,
            active: false
          })
        } else if (element.alt === 'static') {
          // 处理静态
          this.initPosition(element)
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (element.classList.contains(activeClass)) {
            element.classList.remove(activeClass)
          }
          parallax.staticDoms.push({
            dom: element,
            activeClass,
            leftPercentage: element.getAttribute('data-left-percentage') || 0.7,
            active: false
          })
        } else if (element.getAttribute('data-alt') === 'position') {
          this.initPosition(element)
        }
      }
      // 初始化音乐
      const musicContainer = document.getElementById('camera-music-contianer')
      const audioElements = musicContainer.getElementsByTagName('audio')
      for (var i = 0; i < audioElements.length; i++) {
        const element = audioElements[i]
        const imgDom = document.getElementById(element.getAttribute('data-img'))
        const activeClass = imgDom.getAttribute('data-active')
        if (imgDom.classList.contains(activeClass)) {
          imgDom.classList.remove(activeClass)
        }
        parallax.music.push({
          dom: element,
          played: false,
          ended: false,
          imgDom: imgDom,
          endPlayLeft: element.getAttribute('data-end-left') * parallax.imgScale,
          leftPercentage: imgDom.getAttribute('data-left-percentage'),
          activeClass
        })
      }
      // 折叠卡片
      const flipCard1 = document.getElementById('flip-card1')
      if (flipCard1) {
        if (flipCard1.classList.contains('active')) {
          flipCard1.classList.remove('active')
        }
        this.initPosition(flipCard1)
        parallax.extraDom.push({
          idName: 'flipCard1',
          dom: flipCard1,
          leftPercentage: flipCard1.getAttribute('data-left-percentage') || 0.7,
          active: false,
          beginAni: () => {
            flipCard1.classList.add('active')
          }
        })
      }
      const flipCard2 = document.getElementById('flip-card2')
      if (flipCard2) {
        if (flipCard2.classList.contains('active')) {
          flipCard2.classList.remove('active')
        }
        this.initPosition(flipCard2)
        parallax.extraDom.push({
          idName: 'flipCard2',
          dom: flipCard2,
          leftPercentage: flipCard2.getAttribute('data-left-percentage') || 0.7,
          active: false,
          beginAni: () => {
            flipCard2.classList.add('active')
          }
        })
      }
    },
    listenerAnimation() {
      // 获取所有静态dom
      const { screenWidth } = parallax
      for (let i = 0; i < parallax.staticDoms.length; i++) {
        const item = parallax.staticDoms[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          element.classList.add(item.activeClass)
          item.active = true
        }
      }
      // 获取所有音乐dom
      for (let i = 0; i < parallax.music.length; i++) {
        const item = parallax.music[i]
        const imgDom = item.imgDom
        // 已经结束的就跳过
        if (item.ended) continue
        // 正在播放的需要判断结束位置
        if (item.played) {
          //判断停止位置是否到达
          if (parallax.scrollLeftWithScreen >= item.endPlayLeft) {
            this.$emit('playAudio', item.dom)
            item.ended = true
          }
          continue
        }
        if (imgDom.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          this.$emit('playAudio', item.dom)
          item.played = true
          if (item.activeClass) {
            imgDom.classList.add(item.activeClass)
          }
        }
      }
      // 获取所有特殊的dom
      for (let i = 0; i < parallax.extraDom.length; i++) {
        const item = parallax.extraDom[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          item.active = true
          item.beginAni && item.beginAni()
        }
      }
    },
    handleWheel(event) {
      if (this.showMouseTip) {
        this.showMouseTip = false
      }
      event.preventDefault()
      console.log('123123')
      // 判断是否前进后退
      const isForward = event.wheelDeltaY < 0

      if (!this.showResult && parallax.scrollLeftWithScreen / parallax.longImgWidth > 0.17) {
        return
      }

      // 监听动画效果
      this.listenerAnimation()
      // 根据滚动距离修改当前位置
      parallax.curStep = parallax.curStep + (isForward ? 1 : -1) * parallax.wheelStep
      // 限制移动范围，防止移动超出图片边界
      parallax.curStep = Math.max(0, Math.min(parallax.curStep, parallax.scrollMaxLeft))
      if (!this.end && parallax.curStep === parallax.scrollMaxLeft) {
        this.end = true
        this.$emit('end')
      }
      // console.log(parallax.curStep)
      doingNextMove = true
      timer || (timer = setInterval(() => this.changeScrollLeft(), 17))
    },
    changeScrollLeft() {
      const step = (parallax.curStep - parallax.scrollLeft) / parallax.segment
      // 如果滚动步长的绝对值大于设定的最小步长。
      if (Math.abs(step) > parallax.minStep) {
        parallax.scrollLeft += step
        parallax.scrollLeftWithScreen += step
        parallax.dom.style.transform = `translate3d(${-parallax.scrollLeft}px, 0, 0)`
        // 调整layers
        for (let i = 0; i < parallax.layers.length; i++) {
          const layer = parallax.layers[i]
          if (layer.speed > 0 && layer.speed < 1) {
            layer.left = layer.initLeft + parallax.scrollLeft * (1 - layer.speed)
          } else {
            layer.left = layer.initLeft - parallax.scrollLeft * (layer.speed - 1)
          }
          layer.dom.style.transform = `translate3d(${layer.left}px, 0, 0)`
        }
      } else if (doingNextMove) {
        console.log('doingNextMove')
        // 如果当前滚动步长小于等于最小步长，并且标志表明有下一个移动要进行。
        doingNextMove = false
        clearInterval(timer)
        timer = null
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log('created');
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.wheelInit();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (timer) {
      clearInterval(timer)
    }
    parallax.dom.removeEventListener('wheel', this.handleWheel)
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.horwheel-img {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  #camera {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #76c5ff;
  }
  #camera-long-img {
    height: 100%;
  }

  .flip-card {
    position: absolute;
    display: flex;
    .flip-card-item {
      // display: inline-block;
      position: relative;
      width: 230px;
      .flip-card-item-img-wrap {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        perspective: 500px;
        img {
          opacity: 0;
          transform-origin: left center;
          width: 100%;
          box-sizing: border-box;
          object-fit: cover;
          overflow: hidden;
        }
      }
    }
  }
  .flip-card.active {
    & .flip-card-item:nth-of-type(1) {
      img {
        animation: flipCardLeft 0.4s linear forwards;
      }
    }
    & .flip-card-item:nth-of-type(2) {
      img {
        animation: flipCardRight 0.4s linear 0.4s forwards;
      }
    }
  }

  @keyframes flipCardLeft {
    0% {
      transform: rotateY(80deg);
      opacity: 0;
    }
    100% {
      transform: rotateY(-20deg);
      opacity: 1;
    }
  }

  @keyframes flipCardRight {
    0% {
      transform: rotateY(-80deg);
      opacity: 0;
    }
    100% {
      transform: rotateY(20deg);
      opacity: 1;
    }
  }

  .dot-ani {
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #fff;
    z-index: 1;
  }
  .dot-ani-red {
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #d50e0e;
    z-index: 1;
  }

  .mouse-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7%;
    transform: translate(-50%, -50%);
  }
  .before {
    position: absolute;
    width: 20.544%;
    left: 0%;
    top: 0%;
    transition: opacity 1s ease;
  }
  .before-btn {
    position: absolute;
    width: 2.1%;
    left: 11%;
    top: 78.98%;
  }
  .before-btn-hand {
    position: absolute;
    width: 0.3918%;
    left: 12.35%;
    top: 78.58%;
  }
  .after-talk9 {
    position: absolute;
    width: 3.21163%;
    left: 12.9722%;
    top: 8.05556%;
  }
  .person2 {
    position: absolute;
    width: 18.4637%;
    left: 65%;
    bottom: 0;
  }

  .img-speed-bg {
    position: absolute;
    left: 0;
  }
  .img-static-bg {
    position: absolute;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Camera/index.vue